let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("coz7t"), load("a2zKY"), load("8mp4y"), load("i2lta"), load("aVf5m")]).then(() => parcelRequire('5zT9E'));